import { render, staticRenderFns } from "./pondAdd copy.vue?vue&type=template&id=4d926254&scoped=true"
import script from "./pondAdd copy.vue?vue&type=script&lang=js"
export * from "./pondAdd copy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d926254",
  null
  
)

export default component.exports